import { __assign } from "tslib";
import React from 'react';
import { DeveloperCard, dtoToDevCardProps, } from './solution-developer-card';
import { PreviewMode } from '../../preview-elements/preview-context';
import { dtoToTagsBoxProps, TagsBox } from './solution-tag-box';
import s from './solution-overview.scss';
import { composer } from '../../../../component-decorators/composer';
import { config } from '../../../../config';
import { Card } from 'wix-style-react';
import SolutionDescription from './solution-description';
import { categoryFilter } from '../solution-info';
export var dtoToOverViewProps = function (solutionDto) {
    return {
        appId: solutionDto.baseInfo.id,
        benefits: solutionDto.webSolutionData.appData.benefits,
        description: solutionDto.baseInfo.description,
        deveoloperCardProps: dtoToDevCardProps(solutionDto),
        tagsBoxProps: dtoToTagsBoxProps(solutionDto),
        name: solutionDto.baseInfo.name,
        solutionDemo: solutionDto.exampleSites && solutionDto.exampleSites[0],
        biData: {
            app_id: solutionDto.baseInfo.id,
            esi: config.esi || '',
            market: config.originForBI,
            category: categoryFilter(solutionDto && solutionDto.baseInfo.Tags),
        },
    };
};
export var SolutionOverView = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    return (React.createElement("div", { className: s.solutionOverViewContainer },
        React.createElement(SolutionDescription, __assign({}, props)),
        React.createElement("div", { className: s.solutionAppOverviewData },
            React.createElement(PreviewMode.Consumer, null, function (value) {
                return (React.createElement(Card, { className: s.tagsBox },
                    React.createElement(TagsBox, __assign({}, props.tagsBoxProps))));
            }),
            props.deveoloperCardProps && (React.createElement(Card, null,
                React.createElement(DeveloperCard, __assign({}, props.deveoloperCardProps)))))));
});
var hasTags = function (props) {
    return props.tagsBoxProps &&
        !(props.tagsBoxProps.tags === undefined ||
            props.tagsBoxProps.tags.length === 0);
};
//# sourceMappingURL=solution-overview.js.map